export const getters = {
  getContacts($state) {
    return $state.sortOrder.map(contactId => $state.records[contactId]);
  },
  getReports($state) {
    return $state.sortOrder.map(contactId => $state.reports[contactId]);
  },
  getUIFlags($state) {
    return $state.uiFlags;
  },
  getContactableInboxesFetching: $state => id =>
    !!(
      $state.uiFlags.contactableInboxesFetching &&
      $state.uiFlags.contactableInboxesFetching[id]
    ),
  getContactableInboxesFailed: $state => id =>
    !!(
      $state.uiFlags.contactableInboxesFailed &&
      $state.uiFlags.contactableInboxesFailed[id]
    ),
  getContact: $state => id => {
    const contact = $state.records[id];
    return contact || {};
  },
  getMeta: $state => {
    return $state.meta;
  },
  getReportMeta: $state => {
    return $state.reportmeta;
  },
  getAppliedContactFilters: _state => {
    return _state.appliedFilters;
  },
};
